import Toast, { TOAST_TYPES } from "@shared/ui/Toast";
import React from "react";
import { useIntl } from "react-intl";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import enumLoginColors from "$/settings/enums/colors/_login.json";
import AuthPageLayout from "~/components/AuthPageLayout";
import { LoginForm as Form } from "~/components/form";
import { useAuth } from "~/components/general";
import { LOGIN, LOGIN_FAILED } from "~/constants";
import { useGetOemBySlug } from "~/services/auth";
import { registerMixpanelEvent } from "~/utils/_mixpanel";

const Login = () => {
  const { messages: msg } = useIntl();
  const { modifier } = useParams();
  const { search } = useLocation();
  const { oem, error } = useGetOemBySlug(modifier);

  const auth = useAuth();
  const [redirect, setRedirect] = React.useState(false);

  if (redirect) {
    const redirectTo = new URLSearchParams(search).get("redirect");
    const pathname = redirectTo ? decodeURIComponent(redirectTo) : "/app";

    return (
      <Navigate
        to={pathname}
        state={{
          welcome: true,
        }}
        replace
      />
    );
  }

  if (error) {
    if (typeof modifier !== "undefined") {
      return <Navigate to="/error-page/404" replace />;
    }
  }

  var renderPage = () => {
    return (
      <AuthPageLayout>
        <div className="o-column">
          <article className="auth-box">
            <Form
              modifier={modifier}
              color={oem?.textColor || enumLoginColors.text_color}
              callback={(values, setError) => {
                const { email: userEmail } = values;
                registerMixpanelEvent(LOGIN, {
                  oem: window.location.pathname
                    .split("/")
                    .slice(-1)
                    .join("")
                    .split("?")[0],
                  userEmail,
                });
                auth.login(
                  {
                    ...values,
                    organizationId: oem?._id,
                  },
                  (e) => {
                    if (e) {
                      toast(
                        <Toast
                          message={`${msg.login?.wrongCreds}`}
                          type={TOAST_TYPES.ERROR}
                        />,
                        { closeButton: false },
                      );
                      setError("root.random", {
                        type: "random",
                        message: e?.message,
                      });
                      registerMixpanelEvent(LOGIN_FAILED, {
                        oem: window.location.pathname
                          .split("/")
                          .slice(-1)
                          .join("")
                          .split("?")[0],
                        userEmail,
                      });
                    } else {
                      setRedirect(true);
                    }
                  },
                );
              }}
            />
          </article>
        </div>
      </AuthPageLayout>
    );
  };

  return renderPage();
};

const ToastLogin = () => <Login />;

export default ToastLogin;
